
import { User } from "@/models";
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'


export default {
name: "LogInByAccount",
created() {
this.from = this.$route.query.from;
},
props: ["paramA"],
data() {
return {
phone: "",
password: "",
from: ""
};
},
metaInfo() {
return {
title: "登录"
};
},
methods: {
logIn: function () {
if (this.phone == "") {
this.$vux.toast.text("手机号不能为空", "middle");
return;
}

if (this.password == "") {
this.$vux.toast.text("密码不能为空", "middle");
return;
}

User.logInByAccount(this.phone, this.password)
.then(user => {
this.$store.commit("logIn", user.toJSON());
this.$router.push({ path: this.from || "/" });
})
.catch(err => {
this.$vux.toast.text("手机号或密码错误", "middle");
});
},

signUp: function () {
this.$router.push({ name: "signUp", query: { from: this.from } });
},

logInBySmsCode() {
this.$router.push({ name: "logInBySmsCode", query: { from: this.from } });
}
},
components: {
XInput,
Group,
XButton
}
};



// WEBPACK FOOTER //
// ./src/pages/account/LogInByAccount.vue